import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';
import LogoutPage from 'views/pages/Logout';

// login option 3 routing
const AuthLogin3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Login3')));
const AuthRegister3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Register3')));
const XTravexLogin = Loadable(lazy(() => import('views/pages/authentication/authentication3/XTravexLogin')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

// Component that returns null to allow proxy to handle backend routes
function ProxyRoute() {
    return null;
}

const AuthenticationRoutes = {
    path: '/',
    element: <MinimalLayout />,
    children: [
        {
            path: '/',
            element: <AuthLogin3 />,
        },
        {
            path: '/xtravex-login',
            element: <XTravexLogin />,
        },
        // Public backend routes - let proxy handle these
        {
            path: '/s/*',
            element: <ProxyRoute />,
        },
        {
            path: '/m/*',
            element: <ProxyRoute />,
        },
        {
            path: '/og/*',
            element: <ProxyRoute />,
        },
        {
            path: '/track',
            element: <ProxyRoute />,
        },
        {
            path: '*',
            element: <LogoutPage />,
        },
    ],
};

export default AuthenticationRoutes;
